import React, {useState,useEffect} from 'react';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const PlanningBuildLayout = () => {
    const [userCheck, setUserCheck] = useState(false);

    useEffect(() => {
        const userId = localStorage.getItem("adminId");
        setUserCheck(userId === '1');
      }, []);

      const location = useLocation();

    return (
        <div className="main-build-page">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-10 m-auto mt-3 shared-heading">
                        {location.pathname === '/spaceSelect/planning-to-theater' ?(
                        <h3>
                            LETS BUILD
                        </h3>
                        ):(
                            <h3>
                            SHARED PARKING
                            </h3>
                            
                        )}
                        <div className="inside-box">
                          
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PlanningBuildLayout
